export default "__VITE_ASSET__CRQ1ftlO__"